module.exports = __webpack_public_path__ + "img/app-gallery.c5c1d4f6.svg";